export const defaultCurrencyCode = 'USD'

export enum FeeType {
  PERCENT = 'PERCENT',
  FLAT = 'FLAT',
}

export enum DiscountAudience {
  GENERAL = 'GENERAL',
  MEMBERSHIP = 'MEMBERSHIP',
}

//subset of DiscountAudience for booking discounts
export enum BookingDiscountAudience {
  GENERAL = 'GENERAL',
}

export enum DiscountType {
  FLAT = 'FLAT',
  PERCENT = 'PERCENT',
  PRICE = 'PRICE',
  FREE_TRIAL = 'FREE_TRIAL',
}

//subset of DiscountType for booking discounts
export enum BookingDiscountType {
  FLAT = 'FLAT',
  PERCENT = 'PERCENT',
}

export enum BookingFeeType {
  OPTIONAL = 'OPTIONAL', //rename - this name sucks
  PROCESSING = 'PROCESSING',
}

export enum ProcessingFeeDefault {
  //processing fees
  DEFAULT_TICKET_PROCESSING_FEE = 0.1,
  DEFAULT_TABLE_PROCESSING_FEE = 0.04,
  //commissions
  DEFAULT_TABLE_DIRECT_COMMISSION = 0.15,
  DEFAULT_TICKET_DIRECT_COMMISSION = 0,
  //
  GUESTLIST_MAX_DEFAULT = 9,
}

export enum PaymentStatus {
  FULL = 'FULL',
  DEPOSIT = 'DEPOSIT',
  CREDIT_CARD_ON_FILE = 'CREDIT_CARD_ON_FILE',
  NONE = 'NONE',
}

export enum PaymentStatusName {
  FULL = 'Full',
  DEPOSIT = 'Deposit',
  CREDIT_CARD_ON_FILE = 'Auth',
  NONE = 'None',
}

export enum PaymentAmountType {
  FULL = 'FULL',
  DEPOSIT = 'DEPOSIT',
  AUTH = 'AUTH',
  NONE = 'NONE',
  BALANCE = 'BALANCE',
}

export enum PaymentAmountTypeName {
  FULL = 'Prepaid Full',
  DEPOSIT = 'Prepaid Deposit',
  AUTH = 'Authorization',
  NONE = 'No payment',
  BALANCE = 'Balance Due',
}

export enum PaymentProvider {
  STRIPE = 'STRIPE',
}

export enum StripeSubscriptionStatus {
  TRIALING = 'trialing',
  ACTIVE = 'active',
  CANCELED = 'canceled',
  PAST_DUE = 'past_due',
  UNPAID = 'unpaid',
}
